
import $ from "jquery"


const NBSP_TEXT = '\u00A0'
/**
 * 向后/向前，找到第一个满足条件的节点
 * @param {*} node 起点
 * @param {*} satisfy 节点是否满足条件
 * @param {*} [ignore=null] 是否忽略不满足的节点，默认不忽略，如果遇到不能忽略的节点，直接终止搜索
 * @param {*} [forward=false] 是否朝前搜索，默认朝前
 * @returns 
 */
function getFirstSatisfyNode(node, satisfy, ignore = null, forward = false) {
    node = $(node)[0]
    if (!node) return null

    const sibling = forward ? node => node.previousSibling : node => node.nextSibling
    const siblings = (node, nodes = []) => {
        if (!node) return nodes
        const childNodes = [...node.childNodes]
        if (forward) childNodes.reverse()
        childNodes.forEach(childNode => siblings(childNode, nodes))
        nodes.push(node)
        return nodes
    }
    ignore = ignore || (() => false)

    do {
        if (!sibling(node)) {
            let parent = node.parentNode
            while (parent && !sibling(parent)) {
                parent = parent.parentNode
            }
            if (!parent) return null
            node = sibling(parent)
        } else {
            node = sibling(node)
        }
        if (!node) {
            // 空节点
            return null
        } else {
            // 邻居节点
            const siblingNodes = siblings(node)
            for (let siblingNode of siblingNodes) {
                if (siblingNode.nodeType === 8) {
                    // 忽略注释节点
                } else if (satisfy(siblingNode)) {
                    // 满足条件
                    return siblingNode
                } else if (!ignore(siblingNode)) {
                    // 不可忽略
                    return null
                }
            }
        }

    } while (node)

    return null
}

export function getNextSatisfyNode(node, satisfy, ignore = null) {
    return getFirstSatisfyNode(node, satisfy, ignore)
}
export function getPrevSatisfyNode(node, satisfy, ignore = null) {
    return getFirstSatisfyNode(node, satisfy, ignore, true)
}

// 向后找到下一个节点
export function selectNextNode(node, selector) {
    let el = getNextSatisfyNode(
        node,
        node => $(node).is(selector),
        () => true
    )
    // 是编辑器内段落
    if ($(el).is(selector) && isNodeInEditor(el)) {
        return el
    }
    return null
}

// 向后找到下一个节点列表
export function selectNextNodeAll(node, selector) {
    let res = []
    do {
        node = selectNextNode(node, selector)
        if (node) {
            res.push(node)
        }
    } while (node)
    return res
}

// 向前找到第一个相邻的非空节点
export function getPrevSiblingNonEmptyNode(node) {
    const nonEmptyNode = getPrevSatisfyNode(
        node,
        node => $(node).text() !== '',
        node => $(node).text() === ''
    )
    return isNodeInEditor(nonEmptyNode) ? nonEmptyNode : null
}

// 跳过空节点，向前找到第一个相邻的特效节点
export function getPrevSiblingEffectNode(node) {
    let effectNode = getPrevSatisfyNode(
        node,
        node => $(node).is('.isTag') || $(node).find('.isTag').get(0),
        node => {
            const text = $(node).text();
            if (text === '') return true // 跳过空节点
            if (text === NBSP_TEXT && $(node).parents('.isTag')) return true // 跳过特效中的nbsp
            return false
        }
    )
    if ($(effectNode).is('.isTag')) {
        return effectNode
    }
    effectNode = $(effectNode).find('.isTag').last().get(0)
    if (effectNode) {
        return effectNode
    }
    return null
}

// 向后找到下一个段落节点
export function getNextParagraphNode(node) {
    return selectNextNode(node, 'div')
}

// 判断是否是编辑器内节点
function isNodeInEditor(node) {
    return !!(node && $(node).parents('#editor').get(0))
}